/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

export const FUNDING_CASH = 'cash'
export const FUNDING_LOAN = 'loan'

export const FundingMethodCodes = [
  FUNDING_CASH,
  FUNDING_LOAN
]
